import "../account-management.module.css";

import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { cloneDeep } from "lodash";

// Slice
import { uiActions, selectShowModalSpinner } from "stores/slice/ui";

// UI
import SpinnerForModal from "ui/SpinnerForModal";

// Model
import User from "models/User";

// Component
import Button from "components/Button";
import ModalContainer from "components/ModalContainer";
import InputWithIcon from "components/InputWithIcon";
import MessageBoxGroup from "components/MessageBoxGroup";

// Controller
import controller from "../controller";
import { t } from 'i18next';
import AuthUserService from 'services/Auth.User.service';

// Default variable
const defaultMessages = {
  error: ''
};

const DeleteModal = props => {
  const { t } = useTranslation();

  const {
    modalStatus,
    changeModalStatus,
    user,
    currentAccountList,
    successCallback
  } = props;

  const dispatch = useDispatch();
  const showModalSpinner = useSelector(selectShowModalSpinner);
  const publicKey = useSelector(state => state.publicKey);

  const [messages, setMessages] = useState(cloneDeep(defaultMessages));
  const [passwordEye, setPasswordEye] = useState(true);
  const [password, setPassword] = useState('');
  const [notDirty, setNotDirty] = useState(true);
  const [invalid, setInvalid] = useState(true);

  const deletedAccountStatus = {
    idList: [],
    oneAccount: true,
    notIncludedSelf: true,
    notLastOrgOrgAdmin: true
  }

  controller.getDeleteAccountStatus(user, currentAccountList, deletedAccountStatus);

  let confirmMessage = '';
  let lastOrgAdminConfirmMessage = '8e37eb36f4';

  (deletedAccountStatus.oneAccount && deletedAccountStatus.notIncludedSelf) && (confirmMessage = 'cb0ece8810');
  (deletedAccountStatus.oneAccount && !deletedAccountStatus.notIncludedSelf) && (confirmMessage = '792a9e3831');
  (!deletedAccountStatus.oneAccount && deletedAccountStatus.notIncludedSelf) && (confirmMessage = 'ebee83ea89');
  (!deletedAccountStatus.oneAccount && !deletedAccountStatus.notIncludedSelf) && (confirmMessage = '84b3b6a6ad');

  const changePassword = (value) => {
    setNotDirty(false);
    setPassword(value);
    setInvalid(value.length < 8 || value.length > 64);
  }

  const handleDelete = async () => {
    dispatch(uiActions.showModalSpinner());
    const encrypedPassword = User.encryptPassword(publicKey.value.publicKey, password);

    try {
      const response = await AuthUserService.deleteAccount({
        confirmPassword: encrypedPassword,
        userIds: deletedAccountStatus.idList
      });

      if (response.error) {
        throw response.error;
      }

      dispatch(uiActions.hideModalSpinner());
      setMessages(cloneDeep(defaultMessages));
      changeModalStatus('delete', false);
      successCallback();
    } catch (error) {
      setMessages({
        ...messages,
        error: error.code,
        success: null,
      });
      dispatch(uiActions.hideModalSpinner());
    }
  }

  useEffect(() => {
    if (modalStatus.delete) {
      setMessages(cloneDeep(defaultMessages));
      setPasswordEye(true);
      setPassword('');
      setNotDirty(true);
      setInvalid(true);
    }
  }, [modalStatus.delete])

  return (
    <ModalContainer
      modalWidthType="modal-500px"
      openModal={modalStatus.delete.status}
      closeModal={() => changeModalStatus('delete', false)}
    >
      {showModalSpinner && <SpinnerForModal />}
      <div className="header">
        <div className="title">{t('516b10a278')}</div>
      </div>
      <div className='body'>
        <MessageBoxGroup
          messages={messages}
          ErrorMessagesType='es'
          SuccessMessagesType='i18n'
          WarningMessagesType='i18n'
          onClose={(value) => setMessages({ ...defaultMessages, [value]: null })}
        />
        <div className='mb-3 modal-warning-color'>{t(confirmMessage)}</div>
        {
          !deletedAccountStatus.notLastOrgOrgAdmin && (
            <div className='mb-3 modal-warning-color'>{t(lastOrgAdminConfirmMessage)}</div>
          )
        }
        <div className="modal-form-group">
          <div className='modal-form-title required me-3'>{t('dc647eb65e')}</div>
          <div className='modal-form-field'>
            {passwordEye && (
              <InputWithIcon
                type="password"
                placeholder="dc647eb65e"
                autoComplete="new-password"
                value={password}
                isInvalid={!notDirty && invalid}
                onChange={e => changePassword(e.target.value)}
                iconTitle="52a48462f8"
                iconClassName="icon-open-eye"
                iconOnClick={() => setPasswordEye(false)}
              />
            )}
            {!passwordEye && (
              <InputWithIcon
                type="text"
                placeholder="dc647eb65e"
                autoComplete="new-password"
                value={password}
                isInvalid={!notDirty && invalid}
                onChange={e => changePassword(e.target.value)}
                iconTitle="75eebe0662"
                iconClassName="icon-close-eye"
                iconOnClick={() => setPasswordEye(true)}
              />
            )}
          </div>
        </div>
      </div>
      <div className="footer">
        <Button
          label="bafd7322c6"
          className="btn-cancel"
          onClick={() => changeModalStatus('delete', false)}
        />
        <Button
          label="93cba07454"
          className="btn-delete"
          disabled={invalid}
          onClick={handleDelete}
        />
      </div>
    </ModalContainer>
  );
};

export default DeleteModal;
